module.exports = __webpack_public_path__ + "static/img/bg-kiko.48d8dcf9.png";